import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Card, Section } from './Card';

export const About = ({ isVisible }) => (
  <Section
    id="about"
    isVisible={isVisible}
    title={<>About <span style={{ color: COLORS.cantaloupe }}>rockmelon</span></>}
  >
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      <div className="space-y-6 text-lg leading-relaxed" style={{ color: COLORS.slate }}>
        {siteContent.about.paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

      <Card>
        <img
          src={siteContent.about.image}
          alt="Strategic CIO Professional"
          className="w-full h-72 object-cover rounded-xl"
        />
      </Card>
    </div>
  </Section>
);
